import apiClient from "./apiClient";

export const getServices = (page = 1, limit = 30) => apiClient
    .get("/services", { params: { page, limit } })
    .then(res => res);
export const getServiceById = (id) => apiClient.get(`/services/${id}`);
export const createService = (data) => apiClient.post("/services", data);
export const updateService = (id, data) => apiClient.put(`/services/${id}`, data);
export const deleteService = (id) => apiClient.delete(`/services/${id}`);